webpackJsonp([21],{

/***/ 257:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

angular.module('appMarketplace')
    .controller('UpdatePasswordCtrl', ['$scope', '$location', '$state', '$window', '$stateParams', 'NotificationService',
                                      'PasswordService', 'NavigationService', 'UrlService', 'UserService',
                                      function ($scope, $location, $state, $window, $stateParams, NotificationService,
                                                PasswordService, NavigationService, UrlService, UserService) {

        PasswordService.getValidPasswordLength(function successCallback(data) {
            $scope.minPasswordLength = data.minPasswordLength;
            $scope.maxPasswordLength = data.maxPasswordLength;

            $scope.actions = [];
            $scope.manualUpdate = $location.search().manualUpdate === "true" || $stateParams.manualUpdate; //true if user selected update password, false if password is expired
            if ($scope.manualUpdate) {
                $scope.actions.push("Close");
            }
            $scope.requirementsTooltip = kendo.template(angular.element("#requirementsTooltipTemplate").html());

            var windowTitle = "Change" + (!$scope.manualUpdate ? " expired" : "") + " password";
            $scope.window = angular.element("#updatePasswordForm").kendoWindow({
                actions: $scope.actions,
                modal: true,
                pinned: true,
                resizable: false,
                title: windowTitle,
                width: "360px",
                visible: false,
                autoFocus: false,
                close: function () {
                    UserService.showRequiredFormIfAnyNeeded(UrlService.getHashFromUrl() === 'update-password');
                },
                deactivate: function () {
                    $scope.validator.destroy();
                    $scope.window.destroy();
                }
            }).data("kendoWindow").center().open();

            $scope.logOut = function () {
                $window.location.href = UrlService.createAbsoluteUrl('/useradmin/logout.jsp');
            };

            var formErrorTemplate = kendo.template(angular.element("#formErrorTemplate").html());
            $scope.validator = angular.element("#updatePasswordForm").kendoValidator({
                errorTemplate: formErrorTemplate,
                messages: {
                    newPasswordLength: function () {
                        return getPasswordLengthValidationMessage()
                    },
                    newPasswordCase: "Password should contain at least one upper case, one lower case and one numeric character",
                    newPasswordRepeatedChars: 'You may NOT have a password consisting of MORE THAN two consecutive identical characters or MORE than one pair of identical characters.',
                    repeatPassword: "Passwords don't match",
                    required: "Field is required"
                },
                rules: {
                    newPasswordLength: function (input) {
                        if (input.is("[name=newPassword]") && $scope.minPasswordLength && $scope.maxPasswordLength) {
                            var newPasswordLength = input.val().length;
                            return newPasswordLength && newPasswordLength >= $scope.minPasswordLength && newPasswordLength <= $scope.maxPasswordLength;
                        }
                        return true;
                    },
                    newPasswordCase: function (input) {
                        if (input.is("[name=newPassword]")) {
                            return PasswordService.validatePasswordCase(input.val());
                        }
                        return true;
                    },
                    newPasswordRepeatedChars: function (input) {
                        if (input.is("[name=newPassword]")) {
                            return PasswordService.validatePasswordRepeatedChars(input.val());
                        }
                        return true;
                    },
                    repeatPassword: function (input) {
                        if (input.is("[name=repeatPassword]")) {
                            return input.val() === $scope.newPassword;
                        }
                        return true;
                    }
                }
            }).data("kendoValidator");

            $scope.updatePassword = function () {
                if (!$scope.validateForm()) {
                    return;
                }
                PasswordService.updatePassword($scope.oldPassword, $scope.newPassword,
                    function successCallback() {
                        NotificationService.showSuccessMessage('Updated password');
                        NavigationService.getCurrentAccount(function successCallback(currentAccount) {
                            currentAccount.passwordUpdateNeeded = false;
                        });
                        $scope.window.close();
                    }, function errorCallback(responseError) {
                        var errorMsg = responseError.message;
                        if (errorMsg) {
                            NotificationService.showErrorMessage(errorMsg);
                        }
                        $scope.formErrors = [];
                        angular.forEach(responseError.validationErrors, function (error) {
                            $scope.formErrors.push(error);
                        });
                    })
            };

            $scope.validateForm = function () {
                return $scope.validator.validate();
            };

            var getPasswordLengthValidationMessage = function () {
                return "Password length should be between " + $scope.minPasswordLength + " and " + $scope.maxPasswordLength + " characters"
            }
        }, function errorCallback(responseError) {
            NotificationService.showValidationErrors(responseError);
        });
    }]);

/***/ }),

/***/ 258:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

angular.module('appMarketplace')
    .controller('UpdatePasswordHintCtrl', ['$scope', '$location', '$state', '$window', '$stateParams',
                                          'NotificationService', 'UserService', 'NavigationService', 'UrlService',
                                          function ($scope, $location, $state, $window, $stateParams,
                                                    NotificationService, UserService, NavigationService, UrlService) {

        UserService.getPasswordHint(function successCallback(data) {
            $scope.userQuestions = data;
            $scope.userQuestions.userQuestion = $scope.userQuestions.userQuestion || 1; //select default user question

            $scope.actions = [];
            $scope.manualUpdate = $location.search().manualUpdate === "true" || $stateParams.manualUpdate; //true if user selected update password hint, false if password hint is expired
            if ($scope.manualUpdate) {
                $scope.actions.push("Close");
            }

            $scope.window = angular.element("#updatePasswordHintForm").kendoWindow({    // hint
                actions: $scope.actions,
                modal: true,
                pinned: true,
                resizable: false,
                title: "Update password hint",
                width: "360px",
                visible: false,
                autoFocus: false,
                close: function () {
                    UserService.showRequiredFormIfAnyNeeded(UrlService.getHashFromUrl() === 'update-password-hint');
                },
                deactivate: function () {
                    $scope.validator.destroy();
                    $scope.window.destroy();
                }
            }).data("kendoWindow").center().open();

            var formErrorTemplate = kendo.template(angular.element("#formErrorTemplate").html());
            $scope.validator = angular.element("#updatePasswordHintForm").kendoValidator({
                errorTemplate: formErrorTemplate,
                messages: {
                    required: "Field is required"
                }
            }).data("kendoValidator");

            $scope.closeWindow = function () {
                $scope.window.close();
            };

            $scope.logOut = function () {
                $window.location.href = UrlService.createAbsoluteUrl('/useradmin/logout.jsp');
            };

            $scope.updatePasswordHint = function () {
                if (!$scope.validator.validate()) {
                    return;
                }
                UserService.updatePasswordHint($scope.userQuestions.userQuestion, $scope.userQuestions.userAnswer,
                    function successCallback() {
                        NavigationService.getCurrentAccount(function successCallback(currentAccount) {
                            currentAccount.passwordHintUpdateNeeded = false;
                        });
                        $scope.closeWindow();
                        NotificationService.showSuccessMessage('Updated password hint');
                    }, function errorCallback(responseError) {
                        var errorMsg = responseError.message;
                        if (errorMsg) {
                            NotificationService.showErrorMessage(errorMsg);
                        }
                        angular.forEach(responseError.validationErrors, function (error) {
                            $scope.formErrors = [];
                            $scope.formErrors.push(error);
                        });
                    });
            };
        }, function errorCallback(responseError) {
            NotificationService.showValidationErrors(responseError);
        });
    }]);

/***/ }),

/***/ 33:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

angular.module('appMarketplace')
    .service('UserService', ['$http', '$state', 'UrlService', 'NavigationService', function ($http, $state, UrlService, NavigationService) {
        var service = this;

        service.getUserInfo = function (successCallback, errorCallback) {
            var req = {
                method: 'GET',
                url: UrlService.createAbsoluteUrl('/rest/currentAccount/userInfo')
            };

            $http(req).then(function (response) {
                successCallback(response.data);
            }, function (response) {
                errorCallback(response.data)
            })
        };

        service.getAccountCodePreference = function (successCallback, errorCallback) {
            var req = {
                method: 'GET',
                url: UrlService.createAbsoluteUrl('/rest/currentUser/accountCodePreference')
            };

            $http(req).then(function (response) {
                successCallback(response.data);
            }, function (response) {
                errorCallback(response.data)
            })
        };

        service.updateUser = function (user, successCallback, errorCallback) {
            var req = {
                method: 'POST',
                url: UrlService.createAbsoluteUrl('/rest/currentAccount/userInfo'),
                data: user
            };

            $http(req).then(successCallback, function (response) {
                errorCallback(response.data)
            })
        };

        service.getEmailCategoryGroups = function (successCallback, errorCallback) {
            var req = {
                method: 'GET',
                url: UrlService.createAbsoluteUrl('/rest/currentAccount/emailCategoryGroups')
            };

            $http(req).then(function (response) {
                successCallback(response.data);
            }, function (response) {
                errorCallback(response.data)
            })
        };

        service.updateCategoryGroups = function (categoryIds, successCallback, errorCallback) {
            var req = {
                method: 'POST',
                url: UrlService.createAbsoluteUrl('/rest/currentAccount/emailCategoryGroups'),
                data: categoryIds
            };

            $http(req).then(successCallback, function (response) {
                errorCallback(response.data)
            })
        };

        service.getPasswordHint = function (successCallback, errorCallback) {
            var req = {
                method: 'GET',
                url: UrlService.createAbsoluteUrl('/rest/currentUser/passwordHint')
            };

            $http(req).then(function (response) {
                successCallback(response.data);
            }, function (response) {
                errorCallback(response.data)
            })
        };

        service.updatePasswordHint = function (questionId, questionAnswer, successCallback, errorCallback) {
            var req = {
                method: 'POST',
                url: UrlService.createAbsoluteUrl('/rest/currentUser/passwordHint'),
                data: {
                    userQuestion: questionId,
                    userAnswer: questionAnswer
                }
            };

            $http(req).then(successCallback, function (response) {
                errorCallback(response.data)
            })
        };

        service.getApprovalDelegationSettings = function (successCallback, errorCallback) {
            var req = {
                method: 'GET',
                url: UrlService.createAbsoluteUrl('/rest/currentAccount/approvalDelegation')
            };

            $http(req).then(function successCallbackWrapper(response) {
                successCallback(response.data);
            }, function errorCallbackWrapper(response) {
                errorCallback(response.data)
            })
        };

        service.updateApprovalDelegationSettings = function (settings, successCallback, errorCallback) {
            var req = {
                method: 'POST',
                url: UrlService.createAbsoluteUrl('/rest/currentAccount/approvalDelegation'),
                data: settings
            };

            $http(req).then(successCallback,
                function errorCallbackWrapper(response) {
                    errorCallback(response.data)
                })
        };

        service.isAccountCodeValid = function (codeAccount, columnNumber, successCallback, errorCallback) {
            var req = {
                method: 'GET',
                url: UrlService.createAbsoluteUrl('/rest/currentAccount/accountCodeValidity/' + codeAccount),
                params: {column_number: columnNumber}
            };

            $http(req).then(function successCallbackWrapper(response) {
                successCallback(response.data.accountCodeValid);
            }, function errorCallbackWrapper(response) {
                errorCallback(response.data)
            })
        };

        service.acceptPrivacyPolicy = function (successCallback, errorCallback) {
            var req = {
                method: 'POST',
                url: UrlService.createAbsoluteUrl('/rest/currentAccount/acceptPrivacyPolicy')
            };

            $http(req).then(successCallback,
                function errorCallbackWrapper(response) {
                    errorCallback(response.data)
                })
        };

        service.showRequiredFormIfAnyNeeded = function (changeLocation) {
            NavigationService.getCurrentAccount(function successCallback(currentAccount) {
                var state = 'root-state';
                if (!currentAccount.privacyPolicyAccepted) {
                    state = 'accept-privacy-policy-state';
                } else if (currentAccount.passwordUpdateNeeded) {
                    state = 'update-password-state';
                } else if (currentAccount.passwordHintUpdateNeeded) {
                    state = 'update-password-hint-state';
                }
                if ($state.current.name === state) {
                    return;
                }
                $state.go(state, null, {location: changeLocation});
            });
        }
    }]);


/***/ }),

/***/ 512:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(33);
__webpack_require__(257);
__webpack_require__(258);

/***/ })

},[512]);


// WEBPACK FOOTER //
// updatePasswordEntry.js?ver=6ca3b62cabe394f2cce1